import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function BrainTypeField({ value, onChange, testid, label = "Brain Type (1–9)" }) {
  const handle = (e) => {
    const raw = e.target.value;
    if (raw === "") {
      onChange(null);
      return;
    }
    const n = parseInt(raw, 10);
    if (Number.isNaN(n)) return;
    if (n < 1 || n > 9) return;
    onChange(n);
  };
  return (
    <div className="space-y-2">
      <Label className="text-xs font-bold uppercase tracking-[0.2em] text-[#1A1D1A]">{label}</Label>
      <Input
        type="number"
        min={1}
        max={9}
        step={1}
        inputMode="numeric"
        value={value ?? ""}
        onChange={handle}
        placeholder="—"
        data-testid={testid}
        className="h-11 rounded-lg bg-white border-[#E5E2DC] focus-visible:ring-1 focus-visible:ring-[#4A5D4E] focus-visible:border-[#4A5D4E]"
      />
    </div>
  );
}
